const toNumber = (v) => {
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) ? n : undefined;
};

/**
 * Map a partner price/asset payload to display-only quote fields.
 * Does not invent mid. Spread is ask-bid only when both sides are present.
 */
export const quoteFromFeed = (src) => {
  if (!src) return null;
  const last = toNumber(src.price ?? src.last);
  const bid = toNumber(src.bid);
  const ask = toNumber(src.ask);
  const changePercent = toNumber(src.changePercent);
  const spread = bid != null && ask != null ? ask - bid : undefined;
  return {
    last,
    bid,
    ask,
    spread,
    changePercent,
    currency: src.currency || undefined,
  };
};

export const fmtQuotePx = (v) =>
  v != null ? Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—';
